"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_document__pdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "7319907f-d4cc-4175-ab48-d8d230f01a0c",
    x1: 125.08,
    y1: 44.36,
    x2: 159.64,
    y2: 78.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "document-pdf-hi"), /*#__PURE__*/React.createElement("g", {
    id: "e81869f6-d391-450a-bc2f-c28a80841494",
    "data-name": "document-pdf-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5e0e2256-cb64-4048-bc49-d5984998a663",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f4b3e6d5-c161-4e18-80c6-a7986191a0ca",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "502af0d4-c262-4f81-87c0-a19a9daf8956",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "08af4b15-2886-4bd6-a004-7d517c9d6511",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "40c7093c-58fa-4c72-8f61-35ec8a6801c7",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9ead05e3-0062-454b-b161-4335b3997567",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4a04de78-71b9-479a-950e-a8eea896a887",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "06043e50-43b9-436d-9a76-0f71e84a5958",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d34af6a4-db96-442f-867e-3b275156d0fe",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3bde2981-d8a9-45eb-9c45-bca729fc1c7b",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3cff7c98-7629-4294-9a6a-184d0ab6c031",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bd3c5728-ad51-4a43-a51e-188fe618a7c4",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b1ad4df2-f860-426e-a7c1-7461c3e87ba8",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "349dafee-1734-4676-8d20-36f966d8fb2f",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f2c0b38c-eb4b-4eeb-b703-a8975b6cd005",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cf9a79fb-301c-45e6-bb0c-7567e2d68312",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e5a805e4-3773-4ac4-af34-9c489daaf865",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11baa381-5bf3-427f-b81a-0824eef7c49e",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "74034a7a-f270-44ad-a31f-d825aca962bb",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "52d09174-b7ff-44c1-8a54-255d33c81256",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1fe39b6a-b134-4e9d-a9a5-2919aaf1c203",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "72c32ddc-e024-495c-8c16-ad421ca4c9cc",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3325eadd-3fd4-48b6-be32-55c3551a8842",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12b0ad77-693a-4b23-a511-d6d5e8ae5386",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9461ee0a-6bbf-4c3a-bc94-ab1e89fe00ea",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "65139de7-70c7-434d-bb80-892a00aa0b33",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b15f0d09-c514-4d83-b3f5-4e69bea4def8",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3493e337-2285-4b87-a275-f1e7b6bae6cc",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,44V160h0a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16h0V56H128a16,16,0,0,1-16-16V16H56A16,16,0,0,0,40,32V44",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,56H128a16,16,0,0,1-16-16V16Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,54a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h24l-2-2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,56c-.53,0-1.05,0-1.57-.08l-.62-.09c-.3,0-.6-.08-.89-.14s-.53-.12-.79-.19l-.65-.17c-.3-.09-.6-.2-.9-.3l-.47-.17c-.33-.13-.65-.28-1-.43l-.32-.16c-.35-.17-.68-.36-1-.56l-.2-.12q-.54-.33-1-.7l-.09-.07c-.36-.27-.71-.55-1-.84h0L152,86.56V56Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#7319907f-d4cc-4175-ab48-d8d230f01a0c)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.22,125.58a2.73,2.73,0,0,1-2.3-1,3.45,3.45,0,0,1-.77-2.17,3.52,3.52,0,0,1,.77-2.21,2.73,2.73,0,0,1,2.3-1,2.67,2.67,0,0,1,2.28,1,3.59,3.59,0,0,1,.75,2.21,3.52,3.52,0,0,1-.75,2.17A2.67,2.67,0,0,1,55.22,125.58Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,125.1V95.87h8.77a25,25,0,0,1,3.9.28,11.89,11.89,0,0,1,3.46,1.12,6.68,6.68,0,0,1,3.11,3.13,10.08,10.08,0,0,1,1,4.45,10.75,10.75,0,0,1-.75,4,8.72,8.72,0,0,1-1.86,3,7.74,7.74,0,0,1-2.3,1.64,13.44,13.44,0,0,1-3,.85,18.86,18.86,0,0,1-3,.24H68.54V125.1Zm5.52-15.56h3.11a16.45,16.45,0,0,0,2.17-.13,5.34,5.34,0,0,0,1.69-.48,3.61,3.61,0,0,0,1.71-1.58,4.67,4.67,0,0,0-.07-4.43,3.26,3.26,0,0,0-1.78-1.49,10.79,10.79,0,0,0-3.51-.53H68.54Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.09,125.1V95.87h8.24a26.24,26.24,0,0,1,3.51.26,13.35,13.35,0,0,1,3.68,1.05,11.08,11.08,0,0,1,4.32,3.7,14.19,14.19,0,0,1,2.21,4.89,20.69,20.69,0,0,1,.57,4.56,18,18,0,0,1-1,6,12.82,12.82,0,0,1-2.67,4.62,12.16,12.16,0,0,1-3.48,2.67,15.64,15.64,0,0,1-6.93,1.49Zm5.61-5.26H95a10.62,10.62,0,0,0,5-1.1,6.7,6.7,0,0,0,2.94-3.35,12.09,12.09,0,0,0,1-4.8,12.68,12.68,0,0,0-.88-4.71,7.2,7.2,0,0,0-2.72-3.44,7,7,0,0,0-2.39-1,12.57,12.57,0,0,0-2.83-.33H92.7Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.61,125.1V95.87H133.5v5.3H120.22v6.92h10.61v5.22H120.22V125.1Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,174H56a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16v-2A16,16,0,0,1,136,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  })))))))))))))))))))))))))))))));
}

var _default = ic_document__pdf;
exports.default = _default;